import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { GeneralFormEdit } from 'features/inventory/domain/forms/GeneralForm'
import PrebidStackForm from 'features/inventory/domain/forms/PrebidStackForm'
import { PriceGeniusForm } from 'features/inventory/domain/forms/PriceGeniusForm'
import RefresherForm from 'features/inventory/domain/forms/RefresherForm'
import { RichPlacementsFormContainer } from 'features/inventory/domain/forms/RichPlacementsForm'
import UnfilledRecoveryForm from 'features/inventory/domain/forms/UnfilledRecoveryForm'
import ViewabilityToolsForm from 'features/inventory/domain/forms/ViewabilityToolsForm'
import { useAbility } from 'providers/casl'
import { generateSelector } from 'providers/product-fruits/utils'
import { ProductTab } from 'types/productTab'

export const useProductTabs = (): Tab<ProductTab>[] => {
  const { t } = useTranslation('features/domain')
  const { t: tProduct } = useTranslation('features/product')
  const ability = useAbility()

  const cannotAccessDomainEdit = ability.cannot('access', 'DomainPage-edit')

  return [
    {
      disabled: cannotAccessDomainEdit,
      element: 'general',
      label: t('edit.tabs.general'),
      page: <GeneralFormEdit />,
      productFruitsSelector: generateSelector({ step: 1, tour: 2 }),
    },
    {
      authorized: 'Product-prebidStack',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-prebidStack'),
      element: 'prebid-stack',
      label: tProduct('product.prebidStack'),
      page: <PrebidStackForm />,
    },
    {
      authorized: 'Product-refresher',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-refresher'),
      element: 'refresher',
      label: tProduct('product.refresher'),
      page: <RefresherForm />,
    },
    {
      authorized: 'Product-viewabilityTools',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-viewabilityTools'),
      element: 'viewability-tools',
      label: tProduct('product.viewabilityTools'),
      page: <ViewabilityToolsForm />,
    },
    {
      authorized: 'Product-priceGenius',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-priceGenius'),
      element: 'price-genius',
      label: tProduct('product.priceGenius'),
      page: <PriceGeniusForm />,
    },
    {
      authorized: 'Product-unfilledRecovery',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-unfilledRecovery'),
      element: 'unfilled-recovery',
      label: tProduct('product.unfilledRecovery'),
      page: <UnfilledRecoveryForm />,
    },
    {
      authorized: 'Product-richPlacements',
      disabled: cannotAccessDomainEdit || ability.cannot('access', 'Product-richPlacements'),
      element: 'rich-placements',
      label: tProduct('product.richPlacements'),
      page: <RichPlacementsFormContainer />,
      section: 'multi-anchor',
    },
  ]
}
